import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { Component } from "react";
import withFetcher from "../../shared/fetcher";
import { getActionPlanTemplateFromDto, } from "../../shared/domainTypes/task/actionPlanTemplate.type";
import Loading from "../../shared/loading";
class ActionPlanList extends Component {
    renderList(templates) {
        if (!templates.length) {
            return (_jsx("div", { className: "font-italic", children: "No Action Plan Templates found. Press the \"New\" button to create one." }));
        }
        return (_jsxs("table", { className: "table table-striped table-hover table-bordered", children: [_jsx("thead", { children: _jsxs("tr", { children: [_jsx("th", { children: "Id" }), _jsx("th", { children: "Title" }), _jsx("th", { children: "Enabled" }), _jsx("th", { children: "Modified By" }), _jsx("th", { children: "Modified Date" })] }) }), _jsx("tbody", { children: templates.map(this.renderListRow) })] }));
    }
    renderListRow(template) {
        return (_jsxs("tr", { children: [_jsx("td", { children: template.id }), _jsx("td", { children: _jsx("a", { href: "/aviso/app/admin/taskAdmin/actionplan/" + template.id, children: template.templateTitle }) }), _jsx("td", { children: template.enabled ? "Yes" : "No" }), _jsx("td", { children: template.modifiedByPerson
                        ? template.modifiedByPerson.fullName
                        : "Could not find who last modified this template" }), _jsx("td", { children: template.modifiedDate
                        ? template.modifiedDate.toLocaleString()
                        : "Could not find modified date" })] }, template.id));
    }
    render() {
        if (this.props.fetchHasError) {
            return (_jsx("div", { className: "alert alert-danger", children: this.props.fetchErrorMessage
                    ? this.props.fetchErrorMessage
                    : "Sorry, there was an error loading templates" }));
        }
        if (this.props.fetchLoading) {
            return _jsx(Loading, { isLoading: true });
        }
        if (this.props.fetchData && this.props.fetchData.actionPlans) {
            return this.renderList(this.props.fetchData.actionPlans.map((plan) => getActionPlanTemplateFromDto(plan)));
        }
        return (_jsx("div", { children: "There aren't any action plan templates! Click the 'New' button to make one." }));
    }
}
export default withFetcher("/aviso/taskAdmin/actionplans", true)(ActionPlanList);
